import { Link } from 'react-router-dom'
import { Logo } from './Logo'
import type { ApplyNowShellProps } from '../types'

/** Presentational shell — all copy comes from `labels` (content layer). */
export function ApplyNowShell({
  children,
  labels,
  continueLabel,
  onContinue,
  continueDisabled = false,
}: ApplyNowShellProps) {
  return (
    <div className="flex min-h-screen items-start justify-center bg-gray-100 px-3 py-6 pb-24 sm:px-4 sm:py-10 sm:pb-24 md:py-12">
      <div className="w-full max-w-lg rounded-xl bg-white px-4 py-6 shadow-xl xsm:px-5 xsm:py-7 sm:max-w-xl sm:px-8 sm:py-9 md:px-10 md:py-10">
        <Logo />

        <div className="mb-6 sm:mb-8" aria-hidden="true">
          <div className="h-px w-full bg-gray-200" />
        </div>

        {children}

        {onContinue ? (
          <button
            type="button"
            onClick={onContinue}
            disabled={continueDisabled}
            className="mt-6 w-full rounded-md bg-teal-dark px-6 py-3.5 text-base font-bold text-white transition-colors hover:bg-teal-darker disabled:cursor-not-allowed disabled:opacity-50 sm:mt-8"
          >
            {continueLabel ?? labels.continue}
          </button>
        ) : null}

        <div className="relative mt-6 py-2 sm:mt-8">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-200" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="max-w-[90%] bg-white px-3 text-center text-gray-500">
              {labels.alreadyHaveAccount}
            </span>
          </div>
        </div>

        <Link
          to="/login"
          className="mt-4 flex w-full items-center justify-center rounded-md border-2 border-teal-dark bg-white px-6 py-3 text-base font-bold text-teal-dark transition-colors hover:bg-teal-50"
        >
          {labels.signIn}
        </Link>

        <p className="mt-5 text-center text-xs text-gray-400 sm:mt-6">
          {labels.copyright}
        </p>
      </div>
    </div>
  )
}
